// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TagBanner_background__NDzN1 {
  width: 100vw;
  height: 100vh;
  background-color: rgba(42, 40, 40, 0.7);
  position: fixed;
  display: flex;
  justify-content: center;
  z-index: 100;
}

.TagBanner_container__Wa-50 {
  width: 50%;
  height: 90vh;
  min-height: 90vh;
  background-color: var(--color-white);
  box-sizing: border-box;
  box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;
  position: relative;
  bottom: 0;
  border-radius: 10px;
}
@media only screen and (max-width: 43.75em) {
  .TagBanner_container__Wa-50 {
    width: 80%;
  }
}
.TagBanner_container__top__96tEL {
  z-index: 100;
  height: 16rem;
  background-color: var(--color-primary-7);
  position: relative;
  border-radius: 1rem 1rem 0 0;
}
.TagBanner_container__close__s4Puk {
  display: flex;
  justify-content: flex-end;
  padding: 3rem 2rem;
  cursor: pointer;
  z-index: 1000;
}

.TagBanner_content__xyFwH {
  min-height: 80vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 4rem;
}
@media only screen and (max-width: 56.25em) {
  .TagBanner_content__xyFwH {
    padding: 0 2rem;
  }
}
.TagBanner_content_bell__0FVGU {
  position: absolute;
  display: flex;
  width: 100%;
  justify-content: center;
  top: 2rem;
}
.TagBanner_content_bell__img__ADgcI {
  z-index: 100;
}
@media only screen and (max-width: 56.25em) {
  .TagBanner_content_bell__img__ADgcI {
    width: 30rem;
  }
}
.TagBanner_content_line__2xQuw {
  width: 100%;
  margin-top: 6rem;
  border: 0.1px solid var(--color-grey);
}
@media only screen and (max-width: 56.25em) {
  .TagBanner_content_line__2xQuw {
    margin-top: 2rem;
  }
}
.TagBanner_content_btn__qG1BM {
  display: flex;
  width: 100%;
  justify-content: space-between;
  padding: 0 4rem;
  margin-top: 2rem;
  margin-bottom: 4rem;
}
.TagBanner_content_btn__qG1BM > span {
  cursor: pointer;
  font-weight: 900;
  font-size: 2rem;
}
.TagBanner_content_btn__qG1BM > :nth-child(1) {
  color: var(--color-primary);
}
@media only screen and (max-width: 56.25em) {
  .TagBanner_content_btn__qG1BM {
    padding: 0 2rem;
  }
}
@media only screen and (max-width: 500px) {
  .TagBanner_content_btn__qG1BM {
    padding: 0 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/TagBanner/TagBanner.module.scss"],"names":[],"mappings":"AAEA;EACI,YAAA;EACA,aAAA;EACA,uCAAA;EACA,eAAA;EACA,aAAA;EACA,uBAAA;EACA,YAAA;AADJ;;AAIA;EACI,UAAA;EACA,YAAA;EACA,gBAAA;EACA,oCAAA;EACA,sBAAA;EACA,4CAAA;EACA,kBAAA;EACA,SAAA;EACA,mBAAA;AADJ;AAGI;EAXJ;IAYQ,UAAA;EAAN;AACF;AAGI;EACI,YAAA;EACA,aAAA;EACA,wCAAA;EACA,kBAAA;EACA,4BAAA;AADR;AAII;EACI,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;AAFR;;AAMA;EACI,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AAHJ;AAKI;EARJ;IASQ,eAAA;EAFN;AACF;AAII;EACI,kBAAA;EACA,aAAA;EACA,WAAA;EACA,uBAAA;EACA,SAAA;AAFR;AAIQ;EACI,YAAA;AAFZ;AAIY;EAHJ;IAIQ,YAAA;EADd;AACF;AAKI;EACI,WAAA;EACA,gBAAA;EACA,qCAAA;AAHR;AAKQ;EALJ;IAMQ,gBAAA;EAFV;AACF;AAKI;EACI,aAAA;EACA,WAAA;EACA,8BAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;AAHR;AAKQ;EACI,eAAA;EACA,gBAAA;EACA,eAAA;AAHZ;AAMQ;EACI,2BAAA;AAJZ;AAOQ;EAlBJ;IAmBQ,eAAA;EAJV;AACF;AAKQ;EArBJ;IAsBQ,YAAA;EAFV;AACF","sourcesContent":["@import '../variables/breakpoints';\n\n.background {\n    width: 100vw;\n    height: 100vh;\n    background-color: rgba(#2a2828, 0.7);\n    position: fixed;\n    display: flex;\n    justify-content: center;\n    z-index: 100;\n}\n\n.container {\n    width: 50%;\n    height: 90vh;\n    min-height: 90vh;\n    background-color: var(--color-white);\n    box-sizing: border-box;\n    box-shadow: rgba(0, 0, 0, 0.35) 0px 5px 15px;\n    position: relative;\n    bottom: 0;\n    border-radius: 10px;\n\n    @media only screen and (max-width: $bp-700) {\n        width: 80%;\n    }\n\n\n    &__top {\n        z-index: 100;\n        height: 16rem;\n        background-color: var(--color-primary-7);\n        position: relative;\n        border-radius: 1rem 1rem 0 0;\n    }\n\n    &__close {\n        display: flex;\n        justify-content: flex-end;\n        padding: 3rem 2rem;\n        cursor: pointer;\n        z-index: 1000;\n    }\n}\n\n.content {\n    min-height: 80vh;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 0 4rem;\n\n    @media only screen and (max-width: $bp-900) {\n        padding: 0 2rem;\n    }\n\n    &_bell {\n        position: absolute;\n        display: flex;\n        width: 100%;\n        justify-content: center;\n        top: 2rem;\n\n        &__img {\n            z-index: 100;\n\n            @media only screen and (max-width: $bp-900) {\n                width: 30rem;\n            }\n        }\n    }\n\n    &_line {\n        width: 100%;\n        margin-top: 6rem;\n        border: 0.1px solid var(--color-grey);\n\n        @media only screen and (max-width: $bp-900) {\n            margin-top: 2rem;\n        }\n    }\n\n    &_btn {\n        display: flex;\n        width: 100%;\n        justify-content: space-between;\n        padding: 0 4rem;\n        margin-top: 2rem;\n        margin-bottom: 4rem;\n\n        &>span {\n            cursor: pointer;\n            font-weight: 900;\n            font-size: 2rem;\n        }\n\n        &>:nth-child(1) {\n            color: var(--color-primary);\n        }\n\n        @media only screen and (max-width: $bp-900) {\n            padding: 0 2rem;\n        }\n        @media only screen and (max-width: 500px) {\n            padding: 0 0;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"background": `TagBanner_background__NDzN1`,
	"container": `TagBanner_container__Wa-50`,
	"container__top": `TagBanner_container__top__96tEL`,
	"container__close": `TagBanner_container__close__s4Puk`,
	"content": `TagBanner_content__xyFwH`,
	"content_bell": `TagBanner_content_bell__0FVGU`,
	"content_bell__img": `TagBanner_content_bell__img__ADgcI`,
	"content_line": `TagBanner_content_line__2xQuw`,
	"content_btn": `TagBanner_content_btn__qG1BM`
};
export default ___CSS_LOADER_EXPORT___;
